export default "__VITE_ASSET__BfzZjP2b__"